// eslint-disable-next-line import/named
import { baseUrl } from "./baseUrl";

export const getCurrenciesRoute = () => [`${baseUrl}`, "currencies-api", "currencies"].join("/");

export const postCurrenciesRoute = (flag, onDate) =>
  [
    `${baseUrl}/currencies-api/currencies`,
    `?force=${encodeURIComponent(flag)}`,
    `&fromDate=${encodeURIComponent(onDate)}`,
  ].join("");

export const createCurrenciesRoute = () => [`${baseUrl}/currencies-api/currencies`].join("");

export const getCurrenciesVersionsRoute = (id) =>
  [`${baseUrl}`, "currencies-api", "currencies", `${id}`, "versions"].join("/");

export const getCurrenciesVersionsPageableRoute = (id, ...params) =>
  [`${baseUrl}/currencies-api`, "currencies", `${id}`, "versions", "pageable", ...params].join("/");

export const deleteCurrenciesVersionsRoute = (id, onDate) =>
  [`${baseUrl}`, "currencies-api", "currencies", `${id}?onDate=${onDate}`].join("/");

export const getCurrenciesCrossRatesRoute = (onDate) =>
  [`${baseUrl}/currencies-api/currencies/cross-rate`, `?onDate=${encodeURIComponent(onDate)}`].join(
    ""
  );
